import { registerLazyComponent } from './util/lazy';
import { conditionBodyClass, registerPageScript } from './util/page';

// Parts
import './parts/button/button';
import './parts/tile/tile';
import './parts/icon/icon';
import './parts/Tag/Tag';
import './parts/progress-indicator/progress-indicator';
import './parts/loading-indicator/loading-indicator';
import './parts/Overlay/Overlay';
import './parts/SuccessClaim/SuccessClaim';
import './parts/Input/Select';
import './parts/Input/TextInput';
import './parts/Input/Textarea';
import './parts/Input/CustomSelect';
import './parts/Input/FileUpload';
import './parts/Link/Link';
import './parts/Image/Image';
import './parts/Checkbox/Checkbox';
import './parts/Notification/Notification';
import './parts/Grid/Grid';
import './parts/Grid/GridCol';
import './parts/JobFact/JobFact';
import './parts/SocialLink/SocialLink';
import './parts/CardGridInfoTile/CardGridInfoTileGroup';
import './parts/CardGridInfoTile/CardGridInfoTile';
import './parts/RichTextColumns/RichTextColumns';

// Components
import './components/ButtonGroup/ButtonGroup';
import './components/Tab/TabBarItem';
import './components/Tab/TabBar';
import './components/Tab/TabContent';
import './components/Tab/Tabs';
import './components/Tile/TileGroup';
import './components/ImageCard/ImageCard';
import './components/ImageCard/ImageCardGroup';
import './components/TextCard/TextCard';
import './components/TextCard/TextCardGroup';
import './components/TextCard/TextCardCarousel/TextCardCarousel';
import './components/SuccessStory/SuccessStoryCard';
import './components/SuccessStory/SuccessStoryCardGroup';
import './components/SuccessStory/SuccessStoryOverlay';
import './components/SuccessStory/SuccessStoryList';
import './components/Tag/TagGroup';
import './components/Accordion/Accordion';
import './components/Accordion/AccordionItem';
import './components/ContainerHeader/ContainerHeader';
import './components/ContentBlock/ContentBlock';
import './components/TextCard/ReasonCard/ReasonCard';
import './components/TextCard/ReasonCard/ReasonCardGroup';
import './components/Table/Table';
import './components/Table/DataTablePagination';
import './components/Table/PartnerListTable';
import './components/DocumentList/DocumentListItem';
import './components/DocumentList/DocumentList';
import './components/Carousel/ImageCarousel';
import './components/Carousel/ImageCarouselItem';
import './components/Carousel/CarouselPagination';
import './components/CardInCard/CardInCard';
import './components/Card/Card';
import './components/CardGrid/CardGrid';
import './components/SidebarFilter/SidebarFilter';
import './components/ImageGalleryLarge/ImageGalleryLarge';
import './components/ImageGallerySmall/ImageGallerySmall';
import './components/FilterMultiselect/FilterMultiselect';
import './components/StoryCard/StoryCard';
import './components/StoryCard/StoryCardList';
import './components/PaginatedContent/PaginatedContent';
import './components/Layer/Layer';
import './components/LeadSpaceShort/LeadSpaceShort';
import './components/SocialLinks/SocialLinks';
import './components/ContentItem/ContentItem';
import './components/ContentItem/ContentItemList';

// Containers
import './containers/BaseContainer/BaseContainer';
import './containers/Section/Section';
import './containers/TextSection/TextSection';
import './containers/TabSection/TabSection';
import './containers/TabSection/TabSectionContent';
import './containers/SuccessStorySection/SuccessStorySection';
import './containers/ImageCardSection/ImageCardSection';
import './containers/TextCardSection/TextCardSection';
import './containers/ImageTextSection/ImageTextSection';
import './containers/FAQSection/FAQSection';
import './containers/CTABanner/CTABanner';
import './containers/TableSection/TableSection';
import './containers/MediaCardSection/MediaCardSection';
import './containers/ImageBannerSection/ImageBannerSection';
import './containers/DocumentListSection/DocumentListSection';
import './containers/PartnerListSection/PartnerListSection';
import './containers/LeadSpace/LeadSpace';
import './containers/ArticleContent/ArticleContent';

// Global non-WebComponent Containers
import './containers/Quote/Quote';

// Lazy-loaded components
// @ts-ignore
registerLazyComponent('nxt-job-listing', () => import('./components/JobListing/JobListing'));

// Global lazy-loaded pages
import { JobDetailsPage } from './pages/JobDetails/JobDetailsPage';
registerPageScript(conditionBodyClass('job-details'), JobDetailsPage);
